import React from 'react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
import { HazardStripe } from './HazardStripe';
import { offerBullets } from '../data/content';
export function Offer() {
  return <section id="offer" className="scroll-mt-2 bg-graphite" data-id="element-138" data-mp="1mnsecntgiydt">
      <HazardStripe data-id="element-139" data-mp="1hofodu7ahb70" />
      <div className="mx-auto max-w-xl px-3 py-4 text-center sm:px-6" data-id="element-140" data-mp="1hnw80hxaeuv3">
        <p className="inline-block rounded-full bg-hazard px-3 py-0.5 font-display text-[0.66rem] font-extrabold uppercase tracking-[0.18em] text-ink sm:text-xs" data-id="element-141" data-mp="1hqs7iaos9rln">
          SPECIAL LAUNCH OFFER
        </p>
        <h2 className="mt-1.5 font-display text-[1.5rem] font-extrabold uppercase leading-none text-white sm:text-[2.1rem]" data-id="element-142" data-mp="13x16xrt15i22">
          🏗️ CONSTRUCTION <span className="text-hazard" data-id="element-143" data-mp="ywwqu2w1apcd">SITE PRO™</span>
        </h2>
        <p className="mt-1 font-display text-[0.66rem] font-bold uppercase text-steel sm:text-[0.82rem]" data-id="element-144" data-mp="2fbxzhbofape6">
          THE COMPLETE CONSTRUCTION SITE MANAGEMENT SYSTEM
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[260px] sm:max-w-[330px]" target="checkout" data-id="element-145" data-mp="2affse55meeyo" />

        <div className="mt-2 rounded-md border-2 border-hazard bg-ink px-3 py-2.5 text-left" data-id="element-146" data-mp="pml7vloyzhcs">
          <p className="text-center font-display text-base font-extrabold uppercase text-hazard sm:text-xl" data-id="element-147" data-mp="uleklbwfn4bw">
            Complete 6-in-1 System
          </p>
          <ul className="mt-1.5 grid gap-1 sm:grid-cols-2" data-id="element-148" data-mp="13iynsqduvap5">
            {offerBullets.map(b => <li key={b} className="flex items-start gap-1.5 text-[0.76rem] leading-tight text-white sm:text-[0.86rem]" data-id="element-149" data-mp="6v0sxmhrf7hu">
                <span aria-hidden="true" data-id="element-150" data-mp="bt2ag2zjeyr7">✅</span>
                <span data-id="element-151" data-mp="ftvycwczcdk3">{b}</span>
              </li>)}
          </ul>
          <p className="mt-2.5 text-center font-display text-[0.8rem] font-extrabold uppercase leading-tight text-white sm:text-[1rem]" data-id="element-152" data-mp="kl4aw19lwf1h">
            🔥 GET CONSTRUCTION SITE PRO™ TODAY —{' '}
            <span className="whitespace-nowrap rounded bg-hazard px-1.5 text-ink" data-id="element-153" data-mp="3k6t1q00jil4l">$27 USD</span>
          </p>
          <div className="mt-2.5" data-id="element-154" data-mp="vfqtxt7pywnz">
            <CTAButton label="🏗️ GET INSTANT ACCESS" sub="Immediate Digital Access" target="checkout" data-id="element-155" data-mp="vep9wz8q6zu4" />
          </div>
          <p className="mt-2 text-center text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-156" data-mp="qg4hhlzptkg8">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
      <HazardStripe data-id="element-157" data-mp="106z5ovwiuu4b" />
    </section>;
}